import { ForgotForm } from "../../components/auth/ForgotForm";

export const ForgotScreen = () => {
  return <ForgotForm />;
};
